import { Routes } from '@angular/router';

// TODO: Fix for "Failed to load module script: Expected a
//  JavaScript-or-Wasm module but the server responded with
//  a MIME type of "text/html"" &
//  "ERROR TypeError: Failed to fetch dynamically imported module"
import { routes as restaurantRoutes } from './modules/restaurant/restaurant.routing';
import { routes as checkoutRoutes } from './modules/checkout/checkout.routing';
import { routes as orderRoutes } from './modules/order/order.routing';
import { routes as giftCardRoutes } from './modules/gift-card/gift-card.routing';
import { routes as myAccountRoutes } from './modules/my-account/my-account.routing';
import { routes as uiToolkitRoutes } from './modules/ui-toolkit/ui-toolkit.routing';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'auth',
    redirectTo: '/'
  },
  {
    path: 'auth/:page',
    redirectTo: '/'
  },
  {
    path: 'auth/:page/:child',
    redirectTo: '/'
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        children: restaurantRoutes
      },
      {
        path: 'checkout',
        children: checkoutRoutes
      },
      {
        path: 'orders',
        children: orderRoutes
      },
      {
        path: 'gift-card',
        children: giftCardRoutes
      },
      {
        path: 'my-account',
        children: myAccountRoutes
      },
      // TODO: Move to StoryBook
      {
        path: 'ui-toolkit',
        children: uiToolkitRoutes
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
